<template>
  <svg
    class="scaling-svg"
    xmlns="http://www.w3.org/2000/svg"
    width="14.373"
    height="14.374"
    viewBox="0 0 14.373 14.374"
  >
    <path
      d="M9.345,14.374a.719.719,0,0,1-.682-.491L6.62,7.754.491,5.711a.719.719,0,0,1,0-1.364L13.43.034A.769.769,0,0,1,13.645,0l.026,0,.02,0a.7.7,0,0,1,.2.039.565.565,0,0,1,.065.025.682.682,0,0,1,.211.14.677.677,0,0,1,.14.211.585.585,0,0,1,.025.066.677.677,0,0,1,.038.194c0,.007,0,.013,0,.02a.154.154,0,0,1,0,.03.73.73,0,0,1-.034.214L10.026,13.883A.718.718,0,0,1,9.345,14.374Zm2.668-11-4,4,1.335,4ZM11,2.362l-8,2.668,4,1.335Z"
      transform="translate(0 0)"
    />
  </svg>
</template>

<script lang="ts">
import "reflect-metadata";
import { Component, Vue } from "vue-property-decorator";

@Component
export default class SendIcon extends Vue {}
</script>

<style></style>
